
// Home.jsx
import "../styles/home.css";

import { useState, useEffect, useRef, } from "react";
import CategorySlider from "./categoryslider";

import { motion, useAnimation } from "framer-motion";
import bannerImage from '../assets/bannerimg.webp';
import bannerImage2 from "../assets/Artboard.webp";
import bannerImage3 from "../assets/Artboard1.webp";
import bannerImage4 from "../assets/Artboard2.webp";




import Catlogs from "../comopnents/Catlogs";

import {

  FaHeadphones,
  FaMapMarker,
  FaComment,
  FaWrench,

} from "react-icons/fa";
import tool1 from '../assets/powertool.4.jpg';
import tool2 from '../assets/indsul.png';
import tool3 from '../assets/saftey.jpg';
import tool4 from '../assets/qs1.avif';
import { useNavigate } from "react-router-dom";
import { getMenu } from "../services/Spares";
import About from "./About";
import ContactUs from "./ContactUs";
import Testimonials from "../comopnents/testimonials";

const Home = () => {

  const [menu, setMenu] = useState([]);
  // const[brands,setBrands] = useState([]);
  const [currentBanner, setCurrentBanner] = useState(0);

const banners = [bannerImage];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  const fetchMenu = async () => {
    try {
      const response = await getMenu();
      setMenu(response.Data);
      console.log('menu categories:', response.Data);
    } catch (error) {
      console.error('Error fetching menu:', error);
    }
  }

  // const fetchBrands = async () => {
  //   try {
  //     const response = await getBrands();
  //     setBrands(response.Data);
  //     console.log('brands:', response.Data);
  //   } catch (error) {
  //     console.error('Error fetching brands:', error);
  //   }
  // }

  useEffect(() => {
    fetchMenu();
    // fetchBrands();
  }, []);

  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const navigate = useNavigate();

  // Handler function with error checking
  const handleShopNavigation = () => {
    console.log("Navigating to /categories...");
    try {
      navigate("/categories");
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  // Handle category click - navigate to products page
  const handleCategoryClick = (categoryName) => {
    console.log(`Navigating to products page for category: ${categoryName}`);
    // Navigate to products page with category parameter
    navigate(`/products?category=${encodeURIComponent(categoryName)}`);
    // Alternative routes you can use:
    // navigate(`/shopbyspares?category=${encodeURIComponent(categoryName)}`);
    // navigate(`/category/${categoryName.toLowerCase().replace(/\s+/g, '-')}`);
  };

  // Services data (customized for your tools brand)
  const services = [
    {
      title: "Premium Power Tools",
      icon: tool1,
      description: "Engineered with quality materials and advanced technology for superior performance and long-lasting durability."
    },
    {
      title: "Industrial Solutions",
      icon: tool2,
      description: "Providing reliable solutions for workshops, construction projects, manufacturing industries, and service centers."
    },
    {
      title: "Safety First",
      icon: tool3,
      description: "Products developed with strict quality control measures to ensure safe, efficient, and dependable operation."
    },
    {
      title: "Quick Service",
      icon: tool4,
      description: "Dedicated support team providing fast assistance, product guidance, and responsive customer service."
    }
  ];

  return (
    <div style={{ background: "white", overflowX: "hidden" }}>
      {/* YOUR EXISTING NAVIGATION - COMPLETELY UNCHANGED */}
      {/* The navigation stays exactly as it was - I'm not touching it */}

      {/* NEW CEZAN-STYLE HERO SECTION (replaces old hero) */}
      <section
        className="cezan-hero"
        style={{
          height: "50%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Carousel */}
        <div
          className="hero-carousel"
          style={{
            display: "flex",
            width: `${banners.length * 100}%`,
            height: "100%",
            transform: `translateX(-${currentBanner * (100 / banners.length)}%)`,
            transition: "transform 0.8s ease-in-out",
          }}
        >
          {banners.map((image, index) => (
            <div
              key={index}
              style={{
                width: `${100 / banners.length}%`,
                minWidth: `${100 / banners.length}%`,
                height: "95vh",
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "75% center",
                backgroundRepeat: "no-repeat",
              }}
            />
          ))}
        </div>

        {/* Dark Overlay */}
        {/* <div
    style={{
      position: "absolute",
      inset: 0,
      background: "rgba(0,0,0,0.5)",
      zIndex: 1,
      pointerEvents: "none",
    }}
  /> */}

        {/* Content */}
        <div
          className="hero-content"
          style={{
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            color: "#fff",
            zIndex: 2,
            animation: "slideUp 1.2s ease",
          }}
        >
          <h2
            style={{
              fontSize: "34px",
              fontWeight: 500,
              color: "#fff",
              marginBottom: "20px",
            }}
          >
            Powering Industries with Premium <br />
            Power Tools & Spare Parts
          </h2>

          <p
            style={{
              fontSize: "24px",
              color: "#fff",
              marginBottom: "30px",
            }}
          />

          <button
            style={{
              padding: "12px 30px",
              background: "#005487",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "18px",
              fontWeight: 500,
              cursor: "pointer",
            }}
            onClick={handleShopNavigation}
          >
            Shop Now
          </button>
        </div>

        {/* Previous Button */}
        {/* <button
    onClick={() =>
      setCurrentBanner(
        (prev) => (prev - 1 + banners.length) % banners.length
      )
    }
    style={{
      position: "absolute",
      left: "25px",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 3,
      width: "45px",
      height: "45px",
      borderRadius: "50%",
      border: "none",
      background: "rgba(0,0,0,0.45)",
      color: "#fff",
      fontSize: "28px",
      cursor: "pointer",
    }}
  >
    ❮
  </button> */}

        {/* Next Button */}
        {/* <button
    onClick={() =>
      setCurrentBanner((prev) => (prev + 1) % banners.length)
    }
    style={{
      position: "absolute",
      right: "25px",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 3,
      width: "45px",
      height: "45px",
      borderRadius: "50%",
      border: "none",
      background: "rgba(0,0,0,0.45)",
      color: "#fff",
      fontSize: "28px",
      cursor: "pointer",
    }}
  >
    ❯
  </button> */}

        {/* Dots */}
        {/* <div
    style={{
      position: "absolute",
      bottom: "30px",
      left: "50%",
      transform: "translateX(-50%)",
      display: "flex",
      gap: "10px",
      zIndex: 3,
    }}
  >
    {banners.map((_, index) => (
      <button
        key={index}
        onClick={() => setCurrentBanner(index)}
        style={{
          width: currentBanner === index ? "30px" : "10px",
          height: "10px",
          borderRadius: "20px",
          border: "none",
          padding: 0,
          cursor: "pointer",
          background:
            currentBanner === index
              ? "#fff"
              : "rgba(255,255,255,0.5)",
          transition: "all 0.3s ease",
        }}
      />
    ))}
  </div> */}
      </section>
      {/* <Brands /> */}

      {/* CATEGORIES SECTION - FLEX WRAP, NO SCROLL, WITH ROUNDED IMAGES */}
      <CategorySlider />

      {/* <PromoCards /> */}

      {/* <ShopByProfession /> */}

      {/* NEW SERVICES SECTION */}
      <section className="info-fluid" style={{ padding: '80px 0', background: '#fbf8f8' }}>
        <div className="info-inner">
          <div className="info-cards-wrapper" style={{ maxWidth: '1376px', margin: '0 auto', padding: '0 20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px' }}>

            <motion.div
              className="info-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              onClick={() => navigate("/ContactUs")}
              viewport={{ once: true }}
              style={{
                padding: '30px',
                textAlign: 'center',
                background: '#f8f9fa',
                borderRadius: '15px',
                transition: 'border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease'
              }}
            >
              <div className="icon" style={{ fontSize: '40px', color: '#667eea', marginBottom: '20px', width: '100%' }}>
                <FaHeadphones />
              </div>
              <h3 className="title" style={{ fontSize: '18px', marginBottom: '15px' }}>ALWAYS BY YOUR SIDE</h3>
              <p className="desc" style={{ color: '#666', lineHeight: '1.6', textAlign: 'left' }}>
                Committed to delivering quality products backed by reliable support and industry-standard manufacturing practices.
              </p>
            </motion.div>


            <motion.div
              className="info-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              onClick={() => navigate("/ContactUs")}

              style={{
                padding: '30px',
                textAlign: 'center',
                background: '#f8f9fa',
                borderRadius: '15px',
                transition: 'border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease'
              }}
            >
              <div className="icon" style={{ fontSize: '40px', color: '#667eea', marginBottom: '20px', width: '100%' }}>
                <FaMapMarker />
              </div>
              <h3 className="title" style={{ fontSize: '18px', marginBottom: '15px' }}>FIND A LOCAL RETAILER</h3>
              <p className="desc" style={{ color: '#666', lineHeight: '1.6' }}>
                Our products are available through authorized dealers and distributors across India for easy access and support.
              </p>
            </motion.div>

            <motion.div
              className="info-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              onClick={() => navigate("/ContactUs")}

              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              style={{
                padding: '30px',
                textAlign: 'center',
                background: '#f8f9fa',
                borderRadius: '15px',
                transition: 'border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease'
              }}
            >
              <div className="icon" style={{ fontSize: '40px', color: '#667eea', marginBottom: '20px', width: '100%' }}>
                <FaComment />
              </div>
              <h3 className="title" style={{ fontSize: '18px', marginBottom: '15px' }}>HOW CAN WE HELP?</h3>
              <p className="desc" style={{ color: '#666', lineHeight: '1.6' }}>
                Whether you need product information, technical guidance, or business support, our team is ready to assist.
              </p>

            </motion.div>


            <motion.div
              className="info-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              onClick={() => navigate("/warranty")}

              viewport={{ once: true }}
              style={{
                padding: '30px',
                textAlign: 'center',
                background: '#f8f9fa',
                borderRadius: '15px',
                transition: 'border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease'
              }}
            >
              <div className="icon" style={{ fontSize: '40px', color: '#667eea', marginBottom: '20px', width: '100%' }}>
                <FaWrench />
              </div>
              <h3 className="title" style={{ fontSize: '18px', marginBottom: '15px' }}>WARRANTY INFORMATION</h3>
              <p className="desc" style={{ color: '#666', lineHeight: '1.6' }}>
                All products are supported by warranty coverage against manufacturing defects, ensuring customer confidence and satisfaction.
              </p>

            </motion.div>
          </div>
        </div>


        <Testimonials />
        {/* <VerificationSuccess/> */}


        <Catlogs />



        <ContactUs showImages={false} />

      </section>


      {/* CSS Animations */}
      <style>{`
        @keyframes bgMove {
          0% {
            transform: translate(0, 0);
          }
          100% {
            transform: translate(50px, 50px);
          }
        }
        
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
        
        @media (max-width: 768px) {
          .hero-title {
            font-size: 36px !important;
          }
          .contact-inner {
            grid-template-columns: 1fr !important;
          }
          .services-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          }
          .info-cards-wrapper {
            grid-template-columns: 1fr !important;
          }
          .hero-content {
            margin-left: 20px !important;
          }
          .hero-content h1 {
            font-size: 36px !important;
          }
          .hero-content p {
            font-size: 18px !important;
          }
          
          /* Adjust category items for mobile */
          div[style*="flexWrap: wrap"] > div {
            width: 80px !important;
          }
          
          div[style*="borderRadius: '50%'"] {
            width: 70px !important;
            height: 70px !important;
          }
        }

        @media (max-width: 480px) {
          .services-grid {
            grid-template-columns: 1fr !important;
          }
           
        }
      `}</style>
    </div>
  );
};

export default Home;
